import { InvoiceController } from '../../controllers';
import { object, string, number, array, boolean, date } from 'yup';
import { invoiceStore, useStores } from '../../stores';
import NewBulkInvoice from '../../pages/Invoice/NewBulkInvoice';
import React, { useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import * as yup from 'yup';

const NewInvoiceContainer = ({ closeModal, invoiceItem }) => {
	const [loading, setLoading] = useState(false);

	let {
		// appStore: { loading },
		customerStore,
	} = useStores();
	const orders =
		invoiceStore.copiedInvoice?.orders?.map(order => {
			return {
				quantity: order.quantity,
				unitPrice: order.unitPrice,
				item: order.item,
			};
		}) || [];

	const invoiceDetailsValidation = () => {
		return object({
			group: string().required('Select a group'),
			orders: array(
				object({
					availableStockQuantity: number(),
					selectFromStock: boolean(),
					// quantity: number().min(0.1, 'Quantity should be greater than 0.1'),
					quantity: number()
						.when('selectFromStock', {
							is: true,
							then: number()
								.min(1, 'Quantity should be atleast 1')
								.max(yup.ref('availableStockQuantity'), ({ max }) => {
									return `only ${max} units left in stock.`;
								  }),
							otherwise: number().min(1, 'Quantity should be atleast 1'),
						}),
					unitPrice: number().min(1, 'Unit price should be greater than 1'),
					item: string().required('Service is required'),
				})
			),
			vat: boolean().required('Are you charging VAT?'),
			wht: boolean().required('Are you deducting WHT?'),
			// balanceDueDate: string().test(function () {
			// 	const { balanceDueDate } = this.parent;
			// 	return balanceAmount(this.parent) > 0 && !balanceDueDate
			// 		? this.createError({
			// 				message: 'Balance due date is required for the expected balance',
			// 				path: 'balanceDueDate',
			// 		  })
			// 		: true;
			// }),
			currencyCode: string().required('Select Currency'),
			dueDate: date().required('Enter Payment due date'),
			discountPer: number()
				.default(0)
				.min(0, 'Min discount should be greater than 0%')
				.max(100, 'Max discount should be less than or equal to 100%'),
			// depositPer: number()
			// 	.min(1, 'Min deposit should be greater than 1%')
			// 	.max(100, 'Max deposit should be less than or equal to 100%')
			// 	.required('Deposit is required'),
			// salesChannel: string().required('Sales Channel is required'),
			acceptPartPay: boolean(),
			partPayment: number()
				.when("acceptPartPay", {
					is: true,
					then: (schema) => schema.required('Part payment is required'),
					otherwise: (schema) => schema.optional()
				}),

			balanceDueDate: date()
			.when("acceptPartPay", {
				is: true,
				then: (schema) => schema.required('Balance due date is required'),
				otherwise: (schema) => schema.optional()
			})
		});
	};

	const balanceAmount = values => {
		return totalAmountCal(values) - values.partPayment;
	};

	// const balanceAmount = values => {
	// 	let totalAmount = 0;
	// 	if (invoiceItem) {
	// 		totalAmount = depositAmountCal(values);
	// 	} else {
	// 		totalAmount = values.deposit;
	// 	}
	// 	return totalAmountCal(values) - totalAmount;
	// };

	const totalAmountCal = values =>
		totalWithoutDiscount(values) -
		discountAmountCal(values) +
		(values.shipping || 0);

	const totalWithoutDiscount = values => {
		const totalItemPrice = values?.orders?.reduce(
			(previousValue, currentValue) =>
				previousValue + currentValue.quantity * currentValue.unitPrice,
			0
		);
		let totalAmount = totalItemPrice;
		totalAmount = values.vat ? totalAmount + totalAmount * 0.075 : totalAmount;
		totalAmount = values.wht ? totalAmount - totalAmount * 0.05 : totalAmount;
		return totalAmount;
	};
	const discountAmountCal = values =>
		(values.discountPer * totalWithoutDiscount(values)) / 100 || 0;

	const discountPerCal = values =>
		(values.discountAmount / totalWithoutDiscount(values)) * 100 || 0;

	const depositPerCal = values =>
		(values.deposit / totalAmountCal(values)) * 100 || 0;

	const depositAmountCal = values =>
		(values.depositPer * totalAmountCal(values)) / 100 || 0;

	const onSubmit = async values => {
		let payload = {};
		setLoading(true);
		values.orders.forEach(item => {
			if (item.stock === '') {
				delete item.stock;
			}

			delete item.selectFromStock;
			delete item.availableStockQuantity;
		});
		delete values.selectFromStock;
		delete values.groupName;

		if (values.discountPer === '') values.discountPer = 0;
		delete values.paidDate;
		delete values.paymentMethod;
		if (values.partPayment !== 0) {
			values.deposit = values.partPayment
			
		} else {
			values.deposit = totalAmountCal(values);
		}
		
		values.depositPer = values.deposit/totalAmountCal(values) * 100 || 0

		delete values.acceptPartPay;
		delete values.partPayment;

		values.discountAmount = discountAmountCal(values);

		if (values.balanceDueDate === '') {
			delete values.balanceDueDate;
			payload = {
				...values,
				type: 'INVOICE',
				dueDate: values.dueDate.toDateString(),
			};
		} else {
			payload = {
				...values,
				type: 'INVOICE',
				dueDate: values.dueDate.toDateString(),
				// balanceDueDate: values.balanceDueDate.toDateString(),
			};
		}

		const { status, errorMessage } = await InvoiceController.createBulkInvoice(
			payload
		);

		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		MimaToastUtil.error({ message: errorMessage });
	};

	const onCloseModal = () => {
		invoiceStore.setCopiedInvoice({});
		closeModal();
	};

	const goBack = () => {
		closeModal();
	};

	return (
		<NewBulkInvoice
			closeModal={onCloseModal}
			balanceAmount={balanceAmount}
			loading={loading}
			orders={orders}
			invoice={invoiceStore.copiedInvoice}
			discountAmountCal={discountAmountCal}
			depositAmountCal={depositAmountCal}
			customers={customerStore.mappedCustomers}
			onSubmit={onSubmit}
			invoiceDetailsValidation={invoiceDetailsValidation}
			discountPerCal={discountPerCal}
			depositPerCal={depositPerCal}
			goBack={goBack}
		/>
	);
};

export default observer(NewInvoiceContainer);
